import {Card, CardContent, Grid, Typography} from "@material-ui/core";
import {useListContext} from "react-admin";

export const CarrierCashBoxHeader = () => {
    const { selectedIds, data, ids } = useListContext();

    const calcTotals = (list:any) =>
        list.reduce(
            (acc:any, id:any) => {
                const row = data[id] || {};
                acc.total += Number(row.total || 0);
                acc.cash += Number(row.cash || 0);
                acc.check += Number(row.check || 0);
                return acc;
            },
            { total: 0, cash: 0, check: 0 }
        );

    const generalTotals = calcTotals(ids);
    const selectedTotals = calcTotals(selectedIds);

    const renderCard = (label:any, value:any) => (
        <Card>
            <CardContent style={{ padding: 0, paddingLeft: 10 }}>
                <Typography color="textSecondary" gutterBottom>
                    {label}
                </Typography>
                <Typography variant="h5">
                    {value.toFixed(2)} €
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <>
            <Grid container>
                <Grid item xs={4}>
                    {renderCard("Totale", generalTotals.total)}
                </Grid>
                <Grid item xs={4}>
                    {renderCard("Totale contanti", generalTotals.cash)}
                </Grid>
                <Grid item xs={4}>
                    {renderCard("Totale assegni", generalTotals.check)}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={4}>
                    {renderCard("Totale selezionati", selectedTotals.total)}
                </Grid>
                <Grid item xs={4}>
                    {renderCard("Totale contanti selezionati", selectedTotals.cash)}
                </Grid>
                <Grid item xs={4}>
                    {renderCard("Totale assegni selezionati", selectedTotals.check)}
                </Grid>
            </Grid>
        </>
    );
};
